import { ChangeDetectionStrategy, Component, ElementRef, Input, Renderer2 } from '@angular/core';
import { PrintCardContentComponent } from '../../shared/print-card-content.component';
import { GlassHouseBrandGroupIndexCardStackContentViewModel } from './glass-house-brand-group-index-card-stack-content-view-model';
import { GlassHouseBrandGroupCardData } from '../../../../../../../models/print-cards/glass-house/glass-house-brand-group-card-data';

@Component({
  selector: 'app-glass-house-brand-group-index-card-stack-content',
  templateUrl: './glass-house-brand-group-index-card-stack-content.component.html',
  styleUrl: './glass-house-brand-group-index-card-stack-content.component.scss',
  providers: [GlassHouseBrandGroupIndexCardStackContentViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class GlassHouseBrandGroupIndexCardStackContentComponent extends PrintCardContentComponent {
  constructor(
    public override viewModel: GlassHouseBrandGroupIndexCardStackContentViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }

  @Input() override data: GlassHouseBrandGroupCardData;
}
